import styled from 'styled-components'
import colors from '../../../_constants/colors'

export const S_TimeLineNote = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  .note-container {
    position: relative;
    width: 100%;
    padding-left: 30px;
    box-sizing: border-box;
    &:before {
      width: 1px;
      height: 100%;
      content: '';
      border-left: 1px dashed ${colors.FINVOICE_BLUE};
      position: absolute;
      left: -10px;
      top: 23px;
    }
  }

  .note-date {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 5px 0;
    width: 110px;
  }

  .date-timeline-icon {
    display: flex;
    align-items: center;
    svg {
      width: 20px;
      height: auto;
      display: block;
    }
  }

  .note-top-bar {
    .icon {
      padding: 5px;
    }
  }
`
